import {Component, input} from "@angular/core";
import {ThemePalette} from "@angular/material/core";
import {MenuAction} from "@common/ui/action-menu/action-menu.component";
import {Translations} from "@translations";
import {MatFabButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";

export interface SideBarAction {
	fontIcon: string;
	click: () => unknown;
	tooltip: string;
	disabled?: boolean;
	color?: ThemePalette;
}

@Component({
	selector: "sim-side-action-bar",
	templateUrl: "./side-action-bar.component.html",
	styleUrl: "./side-action-bar.component.scss",
	imports: [MatFabButton, TranslateModule, MatTooltip, MatIcon, MatMenu, MatMenuTrigger, MatMenuItem],
})
export class SideActionBarComponent {
	public readonly actions = input.required<SideBarAction[]>();
	/**
	 * These actions will be abstracted behind a menu button. Adding them will display an additional ellipsis button
	 */
	public readonly menuActions = input<MenuAction[]>([]);

	protected readonly T = Translations;
}
